import React from "react";
import {Text} from '@fluentui/react';

const Header = () => {
  return (
      <div style={{marginLeft:50}}>
        <Text variant={'xxLarge'} block>
          To Do List.
        </Text>
      </div>
  );
};

export default Header;
